import gql from "graphql-tag";

export const ADD_NEW_KIT = gql`
    mutation createKit(
        $name: String!
        $ownerId: ID!
        $iconId: ID!
        $public: Boolean!
        $description: String!
    ) {
        createKit(
            name: $name
            ownerId: $ownerId
            iconId: $iconId
            public: $public
            description: $description
        ) {
            ok
            errors
        }
    }
`;

export const SAVE_TO_KIT = gql`
    mutation saveIconToKit($iconId: ID!, $kitId: ID!) {
        saveIconToKit(iconId: $iconId, kitId: $kitId) {
            ok
            errors
        }
    }
`;

export const REMOVE_FROM_KIT = gql`
    mutation removeIconFromKit($iconId: ID!, $kitId: ID!) {
        removeIconFromKit(iconId: $iconId, kitId: $kitId) {
            ok
            errors
        }
    }
`;
